import { FileDropOffSection } from "./FileDropOffSection";

export default FileDropOffSection;
